import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorAffiliate = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      d="M13 10.25V7h-2v3.25H7.5a2.25 2.25 0 0 0-2.25 2.25v1.75H4A1.75 1.75 0 0 0 2.25 16v3c0 .966.784 1.75 1.75 1.75h5A1.75 1.75 0 0 0 10.75 19v-3A1.75 1.75 0 0 0 9 14.25H6.75V12.5a.75.75 0 0 1 .75-.75h9a.75.75 0 0 1 .75.75v1.75H15A1.75 1.75 0 0 0 13.25 16v3c0 .966.784 1.75 1.75 1.75h5A1.75 1.75 0 0 0 21.75 19v-3A1.75 1.75 0 0 0 20 14.25h-1.25V12.5a2.25 2.25 0 0 0-2.25-2.25H13Zm7 5.5a.25.25 0 0 1 .25.25v3a.25.25 0 0 1-.25.25h-5a.25.25 0 0 1-.25-.25v-3a.25.25 0 0 1 .25-.25h5Zm-16 0h5a.25.25 0 0 1 .25.25v3a.25.25 0 0 1-.25.25H4a.25.25 0 0 1-.25-.25v-3a.25.25 0 0 1 .25-.25Z"
    />
    <path fill="#F7A600" d="M9 5a3 3 0 1 1 6 0 3 3 0 0 1-6 0Z" />
  </svg>
);
export default SvgTwoColorAffiliate;
